import { OverlayTrigger, Tooltip } from "react-bootstrap";

const DropdownOverlayFormatter = (cellContent, label, placement) => {
  if (label) {
    return (
      <OverlayTrigger
        placement={!placement ? "right" : placement}
        overlay={
          <Tooltip id="ReferenceTooltip" className="">
            {label ? label : cellContent}
          </Tooltip>
        }
      >
        <span>{cellContent}</span>
      </OverlayTrigger>
    );
  } else return <span>{cellContent}</span>;
};

export default DropdownOverlayFormatter;
